import { render } from "./FamilyEdit.vue?vue&type=template&id=5136bb23&scoped=true&ts=true"
import script from "./FamilyEdit.vue?vue&type=script&lang=ts"
export * from "./FamilyEdit.vue?vue&type=script&lang=ts"

import "./FamilyEdit.vue?vue&type=style&index=0&id=5136bb23&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5136bb23"]])

export default __exports__